import { createApi } from '@reduxjs/toolkit/query/react'
import { gql } from 'graphql-request'
import { graphqlRequestBaseQuery } from '@rtk-query/graphql-request-base-query'

const uniswapTokenAddress = '0x1f9840a85d5af5bf1d1762f925bdaddc4201f984'

// Define a service using a base URL and expected endpoints
export const uniswapApi = createApi({
  reducerPath: 'getUniswap',
  baseQuery: graphqlRequestBaseQuery({ url: 'https://api.thegraph.com/subgraphs/name/uniswap/uniswap-v2' }),
  endpoints: builder => ({
    getUniswapByToken0: builder.query<Array<any>, string | null>({
      query: (token: string | null) => ({
        document: gql`
          {
            pairs(
              first: 500,
              orderBy: reserveUSD,
              orderDirection: desc,
              where: {
                token0: "${token ? token : uniswapTokenAddress}",
              }
            ) {
              id
              token0 {
                id
                symbol
                name
                derivedETH
              }
              token1 {
                id
                symbol
                name
                derivedETH
              }
              reserve0
              reserve1
              reserveUSD
              trackedReserveETH
              token0Price
              token1Price
              volumeUSD
              txCount
            }
          }`,
        variables: null
      }),
      transformResponse: (response: any) => {
        return response.pairs
      }
    }),
    getUniswapByToken1: builder.query<Array<any>, string | null>({
      query: (token: string | null) => ({
        document: gql`
          {
            pairs(
              first: 500,
              orderBy: reserveUSD,
              orderDirection: desc,
              where: {
                token1: "${token ? token : uniswapTokenAddress}",
              }
            ) {
              id
              token0 {
                id
                symbol
                name
                derivedETH
              }
              token1 {
                id
                symbol
                name
                derivedETH
              }
              reserve0
              reserve1
              reserveUSD
              trackedReserveETH
              token0Price
              token1Price
              volumeUSD
              txCount
            }
          }`,
        variables: null
      }),
      transformResponse: (response: any) => {
        return response.pairs
      }
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetUniswapByToken0Query, useGetUniswapByToken1Query } = uniswapApi
